module.exports = __webpack_public_path__ + "static/img/banner2.083cb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.png
// module id = i4Cj
// module chunks = 0